/**
 * One list for the month. The server registry in jobs/phases.js is the
 * writer of the phase. This list is the screen each phase belongs on.
 */
export const GAME_PHASES = [
  { id: 'lobby', label: 'Lobby', screen: 'lobby' },
  { id: 'avatar_selection', label: 'Avatar selection', screen: 'avatars' },
  { id: 'ready_to_start', label: 'Ready', screen: 'avatars' },
  { id: 'start_game', label: 'Landing', screen: 'game' },
  { id: 'land_claim', label: 'Land grant', screen: 'game' },
  { id: 'development', label: 'Cultivation', screen: 'game' },
  { id: 'production', label: 'Grow and use', screen: 'game' },
  { id: 'auction', label: 'Trading', screen: 'auction' },
  { id: 'ended', label: 'Game over', screen: 'game' },
] as const;

export type GamePhaseId = (typeof GAME_PHASES)[number]['id'];
export type GameScreen = (typeof GAME_PHASES)[number]['screen'];

export function phaseById(id: string | undefined) {
  return GAME_PHASES.find((phase) => phase.id === id) || null;
}

export function phaseLabel(id: string | undefined): string {
  return phaseById(id)?.label || 'Game';
}

export function phaseScreen(id: string | undefined): GameScreen {
  return phaseById(id)?.screen || 'game';
}
